module.exports = __webpack_public_path__ + "static/img/6.ee25a1e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/zh/6.png
// module id = oJ0O
// module chunks = 0